import { useThemeContext } from '../contexts/ThemeContext';
import { THEME_PRESETS, type ThemePreset } from '@lib/types/theme';

// Hardcoded colors for each preset (primary + secondary as gradient)
// These must match the Radix color step 9 values used in radix-colors.css
const presetColors: Record<ThemePreset, { primary: string; secondary: string }> = {
  indigo: { primary: '#3e63dd', secondary: '#6e56cf' }, // indigo + violet
  ocean: { primary: '#00a2c7', secondary: '#12a594' }, // cyan + teal
  forest: { primary: '#12a594', secondary: '#29a383' }, // teal + jade
  sunset: { primary: '#e54d2e', secondary: '#e54666' }, // tomato + ruby
  grape: { primary: '#8e4ec6', secondary: '#d6409f' }, // purple + pink
  rose: { primary: '#e93d82', secondary: '#d6409f' }, // crimson + pink
};

export function PresetSwitcher() {
  const { preset, setPreset } = useThemeContext();

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-fg-muted">Preset:</span>
      <div className="flex gap-1">
        {THEME_PRESETS.map((p) => {
          const colors = presetColors[p.name];
          return (
            <button
              key={p.name}
              onClick={() => setPreset(p.name)}
              className={`size-6 rounded-full border-2 transition-all ${
                preset === p.name
                  ? 'border-fg scale-110'
                  : 'border-transparent hover:border-line-hover'
              }`}
              style={{
                background: `linear-gradient(135deg, ${colors.primary} 50%, ${colors.secondary} 50%)`,
              }}
              title={`${p.label} - ${p.description}`}
              aria-label={`Switch to ${p.label} preset`}
            />
          );
        })}
      </div>
    </div>
  );
}
